import { FONT_COPY, FONT_BUTTON, FONT_TITLE } from '../constants/AppConstants';

export default class CopyController {
  constructor(xml) {
    this.copy = {};
    let nodes = xml.getElementsByTagName('item');
    for (let i = 0; i < nodes.length; i++) {
      this.copy[nodes[i].getAttribute('id')] = nodes[i].childNodes[0].nodeValue;
    }
  }

  getCopy(copy_id) {
    return this.copy[copy_id] || 'copy not found [ ' + copy_id + ' ]';
  }

  getCopyNoDefault(copy_id) {
    return this.copy[copy_id] || null;
  }

  createFontStyle({ font, font_size, font_colour, options = {} }) {
    return {
      font: font_size + 'px ' + font,
      fill: font_colour,
      boundsAlignH: options.boundsAlignH || 'center',
      boundsAlignV: options.boundsAlignV || 'middle',
      ...options,
    };
  }
}
